import React, { useState } from "react";

export default function ModalComponent() {
  const [todo, setTodo] = useState([]);
  const [key, setKey] = useState([]);

  const submitHandler = (e) => {
    // e.preventDefault();
    localStorage.setItem(key, todo);
    // e.target.reset();
  };

  const handleTodoChange = (e) => {
    setTodo(e.target.value);
  };

  const handleKeyChange = (e) => {
    setKey(e.target.value);
  };

  return (
    <div>
      <button
        type='button'
        className='btn btn-primary font-custom'
        data-toggle='modal'
        data-target='#exampleModal'
      >
        ADD NEW TODO
      </button>
      <div
        className='modal fade font-custom'
        id='exampleModal'
        tabindex='-1'
        aria-labelledby='exampleModalLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalLabel'>
                Add New Todo
              </h5>
              <button
                type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              <form>
                <div className='mb-3'>
                  <label htmlFor='exampleInputEmail1' className='form-label'>
                    Todo Key
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='data'
                    required
                    onChange={handleKeyChange}
                  />
                </div>
                <div className='mb-3'>
                  <label htmlFor='exampleInputEmail1' className='form-label'>
                    Todo Name
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    id='data'
                    required
                    onChange={handleTodoChange}
                  />
                </div>
                <button
                  type='submit'
                  className='btn btn-primary'
                  onClick={submitHandler}
                >
                  ADD
                </button>
              </form>
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-dismiss='modal'
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
